import React, { useState } from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";
import CmsHiringDetails from "@/bit/components/components.cms-block.cms-hiring-details";

import ConfirmDeleteCard from "./delete-item";

/**
 * Componente que renderiza las bolitas de edicion de los elementos
 */
function EditableGroupIcons({
  elementProps,
  visibleTools,
  deleteProps,
  cmsHandler,
  noCustomLink = false
}) {
  const [maxWidth, setmaxWidth] = useState(false) // controlar que el borrar elemento oculte el resto de iconos cuando se clicka
  const { editName, hiringDetails } = elementProps;
  const { index, itemIdDotNotation, alias, frontalListToDelete } = deleteProps;
  const { hiring, edit, deleteItem } = visibleTools; // Maneja que bolitas salen

  if (!cmsHandler) {
    return null;
  }

  return (
    <div className={`editable-group-elements${maxWidth ? " max-width" : ""}${noCustomLink ? " noRightMargin" : ""}`}>
      {edit && editName && !maxWidth && (
        <span
          className={"element-editable block edit-component"}
          onClick={() =>
            cmsHandler({
              ...elementProps,
              name: editName,
            })
          }
        >
          <IconGlyph id="lapiz-m" width={22} color="white" />
        </span>
      )}
      {hiring && hiringDetails && !maxWidth && (
        <CmsHiringDetails {...hiringDetails} cmsHandler={cmsHandler} />
      )}
      {deleteItem && alias && (index || index === 0) && itemIdDotNotation && (
        <ConfirmDeleteCard
          {...{
            cmsHandler,
            itemIndex: index,
            alias,
            itemIdDotNotation,
            setmaxWidth,
            frontalListToDelete
          }}
        />
      )}
    {/* INJECT_STYLED_JSX_TAG */}
    </div>
  );
}

export default EditableGroupIcons;
